import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Components/Footer";
import Header from "../Components/Header";

export default function BasePage() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
     
    </>
  );
}
